var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87508 7.49935C6.87508 5.77346 8.27419 4.37435 10.0001 4.37435C11.726 4.37435 13.1251 5.77346 13.1251 7.49935C13.1251 9.22524 11.726 10.6243 10.0001 10.6243C8.27419 10.6243 6.87508 9.22524 6.87508 7.49935ZM10.0001 5.62435C8.96455 5.62435 8.12508 6.46382 8.12508 7.49935C8.12508 8.53488 8.96455 9.37435 10.0001 9.37435C11.0356 9.37435 11.8751 8.53488 11.8751 7.49935C11.8751 6.46382 11.0356 5.62435 10.0001 5.62435Z",
    fill: "#0A0A0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 9.99935C1.04175 5.0518 5.05253 1.04102 10.0001 1.04102C14.9476 1.04102 18.9584 5.0518 18.9584 9.99935C18.9584 14.9469 14.9476 18.9577 10.0001 18.9577C5.05253 18.9577 1.04175 14.9469 1.04175 9.99935ZM10.0001 2.29102C5.74289 2.29102 2.29175 5.74215 2.29175 9.99935C2.29175 12.1207 3.14864 14.0418 4.53517 15.4356C4.6855 14.6247 4.98087 13.8601 5.57372 13.2453C6.46052 12.3256 7.87855 11.8743 10 11.8743C12.1215 11.8743 13.5396 12.3256 14.4264 13.2453C15.0192 13.8601 15.3146 14.6247 15.4649 15.4357C16.8515 14.0419 17.7084 12.1207 17.7084 9.99935C17.7084 5.74215 14.2573 2.29102 10.0001 2.29102ZM14.3281 16.3788C14.2432 15.3689 14.024 14.6288 13.5265 14.1129C12.9853 13.5516 11.9825 13.1243 10 13.1243C8.01758 13.1243 7.01476 13.5516 6.47354 14.1129C5.97614 14.6288 5.75684 15.3689 5.67194 16.3788C6.90578 17.2175 8.39569 17.7077 10.0001 17.7077C11.6044 17.7077 13.0943 17.2175 14.3281 16.3788Z",
    fill: "#0A0A0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientIcon);
export default __webpack_public_path__ + "static/media/client-icon.be7b31e655e071c8d796ce29d7daa39f.svg";
export { ForwardRef as ReactComponent };